<template>
  <AgreementPop
    :show="show"
    :value="value"
    title="共享经济合作伙伴协议"
    checkText="我已阅读并确认协议"
    @input="handleAgree"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <Protocol></Protocol>
  </AgreementPop>
</template>

<script>
import AgreementPop from '../index'
import Protocol from './Protocol'

export default {
  name: 'OCACSA',
  props: {
    show: Boolean,
    number: Number,
    value: Boolean,
  },
  components: {
    AgreementPop,
    Protocol,
  },
  methods: {
    handleAgree (value) {
      this.$emit('input', value)
    },
    handleConfirm (value) {
      this.$emit('confirm', value)
    },
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>
